import { Link } from 'react-router-dom'
import { TALYNTH_LAUNCH_BANNER, TALYNTH_LIVE } from '../config/site'

/**
 * Pre-launch notice for Talynth, shown on the Home and Products pages while
 * {@link TALYNTH_LIVE} is `false`. Renders nothing once Talynth is live, so the
 * single config flag controls both the banner and the (re-)enabling of the
 * talynth.tech links elsewhere.
 */
export function LaunchBanner() {
  if (TALYNTH_LIVE) return null

  return (
    <div className="launch-banner" role="status">
      <div className="container launch-banner__inner">
        <span className="launch-banner__badge">Coming soon</span>
        <p className="launch-banner__text">{TALYNTH_LAUNCH_BANNER}</p>
        <Link className="btn btn--primary launch-banner__cta" to="/contact">
          Register interest
        </Link>
      </div>
    </div>
  )
}

export default LaunchBanner
